<template>
  <div class="container-main">
    <div class="container-main-header-button">
      <v-btn depressed @click="back">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <span v-if="$route.params.id">Редактировать социальную сеть</span>
      <span v-else>Добавить социальную сеть</span>
    </div>
    <v-form ref="formFirst">
      <div class="container-block">
        <div>
          <v-text-field label="Ссылка" required type="text" outlined :rules="[
            (v) => !!v || 'Обязательно к заполнению',
            (v) => checkValidUrl(v) || '',
          ]" v-model="item.link"></v-text-field>
        </div>
      </div>
      <div class="container-block">
        <div class="container-block-title">
          Параметры публикации и отображения
        </div>
        <div class="d-flex align-center">
          <v-switch v-model="item.isHidden" hide-details color="var(--app-green-1)"></v-switch>
          <span class="switch-label">Скрыть из списка социальные сети (социальная сеть не будет
            отображаться)</span>
        </div>
      </div>
    </v-form>
    <div class="container-block" style="width: 100%">
      <div class="container-block-title">Прикрепить иконки</div>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Формат</th>
              <th class="text-left">Место отображенния</th>
              <th class="text-left">Иконка</th>
              <th class="text-left"></th>
            </tr>
          </thead>
          <tbody>
            <tr style="height: 60px">
              <td class="text-left">iOS</td>
              <td class="text-left">
                Иконка будет отображаться на телефонах на платформе iOS
                <br />Прикрепить файл формата pdf
              </td>
              <td class="text-left">
                <v-btn v-if="!newImageIOS" class="button-accept" @click="onButtonClick">
                  Загрузить pdf
                </v-btn>
                <input v-if="!newImageIOS" ref="uploader" class="d-none" type="file" accept="application/pdf"
                  @change="onFileChanged" />

                <a v-else target="_blank" :href="imgSrcIOS">
                  <span v-if="newImageIOS.name">{{ newImageIOS.name }}</span>
                  <span v-else>Иконка</span>
                </a>
              </td>

              <td class="text-left">
                <v-btn icon @click="deleteImageIOS">
                  <v-icon color="var(--app-red-1)"> mdi-delete-outline </v-icon>
                </v-btn>
              </td>
            </tr>
            <tr style="height: 60px">
              <td class="text-left">Android</td>
              <td class="text-left">
                Иконка будет отображаться на телефонах на платформе Android
                <br />
                Прикрепить файл формата svg
              </td>
              <td class="text-left">
                <v-btn v-if="!newImageAND" class="button-accept" @click="onButtonClickAND">
                  Загрузить svg
                </v-btn>
                <input v-if="!newImageAND" ref="uploaderAND" class="d-none" type="file" accept="image"
                  @change="onFileChangedAND" />
                <img style="max-width: 50px; max-height: 50px" v-else :src="imgSrcAND" />
              </td>

              <td class="text-left">
                <v-btn icon @click="deleteImageAND">
                  <v-icon color="var(--app-red-1)"> mdi-delete-outline </v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <v-alert color="var(--app-red-1)" type="error" v-model="errImages">
        Загрузите все изображения
      </v-alert>
      <v-divider></v-divider>
    </div>

    <div class="container-block-footer-buttons">
      <div>
        <v-btn @click="saveSocial" style="width: auto !important" class="button-accept">
          Сохранить
        </v-btn>
      </div>
      <div>
        <v-btn v-if="$route.params.id" @click="dialogDelete = true" outlined style="width: auto !important"
          color="var(--app-red-1)" class="button-accept-outlined">
          Удалить
        </v-btn>
      </div>
    </div>
    <v-dialog width="600px" height="auto" persistent v-model="dialogDelete">
      <v-card>
        <v-card-title class="dialog-title">
          <span class="title">Точно хотите удалить социальную сеть?</span>
          <v-icon @click="dialogDelete = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-actions class="dialog-buttons">
          <v-btn @click="dialogDelete = false" style="width: 120px" outlined color="var(--app-green-1)">
            Нет
          </v-btn>
          <v-btn @click="deleteItem" style="width: 120px" outlined color="var(--app-red-1)">
            Да
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>


export default {
  data: () => ({
    errImages: false,
    dialogDelete: false,
    pages: [],
    item: {
      isHidden: false,
    },

    rules: [(value) => !!value || "Обязательно к заполнению"],

    newImageIOS: null,
    imgSrcIOS: "",

    newImageAND: null,
    imgSrcAND: "",
  }),

  methods: {
    back() {
      this.$router.push({ name: "Appeal", params: { selectedTicker: 2 } });
    },
    onButtonClick() {
      this.$refs.uploader.click();
    },
    onButtonClickAND() {
      this.$refs.uploaderAND.click();
    },

    onFileChanged(e) {
      this.errImages = false;
      this.newImageIOS = e.target.files[0];
      this.imgSrcIOS = URL.createObjectURL(this.newImageIOS);
    },
    onFileChangedAND(e) {
      this.errImages = false;
      this.newImageAND = e.target.files[0];
      this.imgSrcAND = URL.createObjectURL(this.newImageAND);
    },
    deleteImageIOS() {
      this.newImageIOS = null;
      this.imgSrcIOS = "";
    },
    deleteImageAND() {
      this.newImageAND = null;
      this.imgSrcAND = "";
    },
    getSocial() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV5 +
            "/appeal/social/" +
            this.$route.params.id,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          this.item = res.data;
          this.newImageIOS = this.item.imageIos;
          this.newImageAND = this.item.imageAndroid;
          this.imgSrcIOS = this.item.imageIos;
          this.imgSrcAND = this.item.imageAndroid;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    saveSocial() {
      if (this.$refs.formFirst.validate()) {
        if (this.newImageIOS && this.newImageAND) {
          let formData = new FormData();
          if (this.item.id) {
            formData.append("appealSocialId", this.item.id);
          }
          formData.append("link", this.item.link);
          formData.append("isHidden", this.item.isHidden);

          formData.append("imageIos", this.newImageIOS);
          formData.append("imageAndroid", this.newImageAND);

          this.$axios
            .post(
              this.$store.getters.apiAdminPanelV2 + "/appeal/social",
              formData,
              {
                headers: {
                  authorization: this.$store.getters.adminPanelHeaderAuth,
                },
              }
            )
            .then(() => {
              this.$router.push({ name: "Appeal" });
            })
            .catch((err) => {
              this.$store.commit("errorSet", true);
              this.$store.commit("errorTextSet", err);
            });
        } else {
          this.errImages = true;
        }
      }
    },
    deleteItem() {
      this.$axios
        .delete(this.$store.getters.apiAdminPanelV2 + "/appeal/social", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            appealSocialId: this.$route.params.id,
          },
        })
        .then(() => {
          this.$router.push({ name: "Appeal" });
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
  },
  created() {
    if (this.$route.params.id) {
      this.getSocial();
    }
  },

  watch: {},
};
</script>
<style lang="scss" scoped>
.container-main {
  box-sizing: border-box;

  padding: 40px !important;

  .container-main-header-button {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    span {
      font-size: 28px;
      font-weight: 400;
      margin-left: 16px;
    }
  }

  .container-block {
    width: 50%;
    margin-bottom: 20px;

    .container-block-title {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 16px;
    }

    .container-block-gallery-button {
      text-decoration: underline;
      color: #1064dd;
      font-size: 18px;
      font-weight: 400;
      cursor: pointer;
      padding-bottom: 20px;
    }

    .table-img {
      // width: 62px;
      height: 38px;
      object-fit: contain;
    }
  }

  .container-block-footer-buttons {
    display: flex;
    justify-content: space-between;
    width: 50%;
    margin-top: 60px;
  }
}

.dialog-tablet-img {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  img {
    width: 658;
    height: 192;
  }
}

.switch-label {
  font-size: 16px;
  color: #0000009a;
  margin-bottom: 2px;
}
</style>